import { Injectable, Inject } from '@angular/core';
import { BookingService } from './booking.service';
import { CONSTANTS } from '../../../constants/constants';

@Injectable()
export class BoardingPassService {
	private brand: string;
	private loyaltyClasess: any = {};

	constructor(public bookingService: BookingService, @Inject(CONSTANTS) private constants: any) {
		this.brand = this.bookingService.getBrand();
		this.loyaltyClasess[this.constants.BRANDS_NAMES.ROYAL] = ['gold', 'platinum', 'emerald', 'diamond', 'diamond plus', 'pinnacle club'];
		this.loyaltyClasess[this.constants.BRANDS_NAMES.CELEBRITY] = ['preview', 'classic', 'select', 'elite', 'elite plus', 'zenith'];
	}

	public getLoyaltyClassValueIfValid(loyalty: string) {
		const result = this.loyaltyClasess[this.brand].find((e: any) => e === loyalty);
		return result ? result : null;
	}
}
